
import React, {Component} from 'react';
import {Modal,FormControl,Button,ButtonToolbar} from 'react-bootstrap'
import WorkdocStore from '../../stores/WorkdocStore'

class SWTCarCatModal extends Component {

  constructor(...args){
    super(...args)
    this.state = {text:''}
  }

  onSaveClick(){
    
    let {text} = this.state
    let that = this
    WorkdocStore.saveCarCategory(this.props.catId,text,function(result){
      that.props.onAfterSubmit()
      that.props.onHide()
    })
  }

  onChange(e){
    this.setState({text:e.target.value})
  }

  render(){
    let {show,title,text} = this.props
    
    return (
      <Modal show={show} enforceFocus={false} onHide={this.props.onHide} dialogClassName="smallwidth-dialog">
        <Modal.Header closeButton>
          <Modal.Title>{'เพิ่มรายการใน '} {title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <FormControl value={text} onChange={this.onChange.bind(this)}/>
        </Modal.Body>
        <Modal.Footer>
          <ButtonToolbar className='pull-right'>
            <Button bsStyle={'primary'} onClick={this.onSaveClick.bind(this)}>บันทึก</Button>
            <Button onClick={this.props.onHide}>ปิด</Button>
          </ButtonToolbar>
        </Modal.Footer>
      </Modal>
    )
  }
}


export default SWTCarCatModal;





// WEBPACK FOOTER //
// ./src/view/workdoc/SWTCarCatModal.js